(() => {
  // TODO i18n: UI strings rendered from JS are hardcoded German ("${this.max} Meals", "p.P."). Move to the locale files or remove before launching another market.
  const input = (meal) => meal.querySelector('.nrb-qty__input');
  // Sold-out meals render no stepper (no input), so treat them as quantity 0.
  const qtyOf = (meal) => { const el = input(meal); return el ? parseInt(el.value, 10) || 0 : 0; };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  class Configurator {
    constructor(app) {
      this.app = app;
      this.meals = [...app.querySelectorAll('.nrb-meal')];
      this.mealsGrid = app.querySelector('.nrb-meals');
      this.breakerSources = [...app.querySelectorAll('.pm-0123-breaker .pm-0123-breaker-item')];
      this.sizes = [...app.querySelectorAll('.nrb-size')];
      this.amount = app.querySelector('.nrb-amount');
      this.subscribe = app.querySelector('.nrb-subscribe__toggle');
      this.frequencies = [...app.querySelectorAll('.nrb-frequency')];
      this.frequency = this.frequencies[0];
      this.buy = app.querySelector('.nrb-buy');
      this.addingLabel = app.querySelector('.nrb-adding-label');
      this.config = app.querySelector('.nrb-configuration');
      this.modal = app.querySelector('.nrb-modal');
      this.modalAtc = this.modal?.querySelector('.nrb-modal__atc');
      this.modalProducts = this.modal?.querySelector('[data-products]');
      this.modalTitle = this.modal?.querySelector('.nrb-modal__title');
      this.modalPriceNew = this.modal?.querySelector('.nrb-modal__price-new');
      this.modalPriceOld = this.modal?.querySelector('.nrb-modal__price-old');
      // AT legacy modal only: in-popup subscription/one-time switch + frequency wrapper (null elsewhere).
      this.planSwitch = this.modal?.querySelector('[data-plan-switch]');
      this.planFrequency = this.modal?.querySelector('[data-at-frequency]');
      this.msg = this.modal?.querySelector('.nrb-cart__msg');
      this.infoModal = app.querySelector('.nrb-info');
      this.collectionId = app.dataset.collectionId;
      this.bundleProductId = app.dataset.bundleProductId;
      this.bundleHandle = app.dataset.bundleHandle;
      this.cartError = app.dataset.cartError || '';
      // Optional campaign discount the cart applies on top of the box tier. Floored later so the popup never shows less than the cart charges.
      this.extraDiscountPct = Math.max(0, parseFloat(app.dataset.extraDiscount) || 0);
      // Optional discount code applied to the cart on add-to-cart. Empty = off.
      this.discountCode = (app.dataset.discountCode || '').trim();
      this.filtersEl = app.querySelector('[data-filters]');
      this.filtersOpen = this.filtersEl?.querySelector('[data-open]');
      this.quickEl = this.filtersEl?.querySelector('[data-quick]');
      this.filterCountEl = this.filtersEl?.querySelector('.nrb-filters__count');
      this.sidebar = app.querySelector('[data-sidebar]');
      this.sidebarGroups = this.sidebar?.querySelector('[data-sidebar-groups]');
      this.filterGroups = [];
      this.activeTags = new Set();
      this.max = 0;
      this.wasFull = false;

      this.sizes.forEach((s) => s.addEventListener('click', () => this.selectSize(s)));
      this.meals.forEach((m) => this.bindMeal(m));
      this.meals.forEach((m) => {
        const media = m.querySelector('.nrb-meal__media');
        if (!media) return;
        media.addEventListener('click', () => this.openInfo(m));
        media.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.openInfo(m); }
        });
      });
      this.infoModal?.querySelectorAll('[data-info-close]').forEach((el) => el.addEventListener('click', () => this.closeInfo()));
      if (this.subscribe) this.subscribe.addEventListener('change', () => { this.syncDelivery(); this.syncPlanUI(); if (this.modal && !this.modal.hidden) this.renderModal(); });
      this.frequencies.forEach((sel) => sel.addEventListener('change', () => {
        this.frequencyTouched = true;
        this.mirrorFrequency(sel.value);
        if (this.modal && !this.modal.hidden) this.renderModal();
      }));
      if (this.buy) this.buy.addEventListener('click', () => this.addToCart());
      if (this.filtersOpen) this.filtersOpen.addEventListener('click', () => this.openSidebar());
      this.sidebar?.querySelectorAll('[data-sidebar-close]').forEach((el) => el.addEventListener('click', () => this.closeSidebar()));
      this.sidebar?.querySelector('[data-sidebar-reset]')?.addEventListener('click', () => this.resetFilters());
      if (this.modalAtc) this.modalAtc.addEventListener('click', () => this.addToCart());
      this.modal?.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.closeModal()));
      this.modal?.querySelectorAll('[data-upsell] button').forEach((btn) => btn.addEventListener('click', () => this.applyUpsell(btn)));
      this.planSwitch?.querySelectorAll('[data-plan]').forEach((btn) => btn.addEventListener('click', () => this.selectPlan(btn.dataset.plan === 'sub')));
      document.addEventListener('keydown', (e) => this.onKeydown(e));
      if (this.breakerSources.length) {
        let rt;
        window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => this.placeBreakers(), 150); });
      }
      this.syncDelivery();
      this.syncPlanUI();
      this.setupStickyConfig();

      const active = this.readVariantUrl() ?? this.sizes.find((s) => s.classList.contains('is-active')) ?? this.sizes[0];
      if (active) this.applySize(active);
      this.render();
      this.setupFilters();
    }

    setupStickyConfig() {
      const sentinel = this.app.querySelector('.nrb-config-sentinel');
      if (!this.config || !sentinel) return;
      const observer = new IntersectionObserver(
        ([entry]) => this.config.classList.toggle('is-pinned', !entry.isIntersecting && entry.boundingClientRect.top < 0),
        { threshold: [0] }
      );
      observer.observe(sentinel);
    }

    whenRecharge() {
      return new Promise((resolve) => {
        if (window.recharge && window.__rechargeInitialized) return resolve(window.recharge);
        document.addEventListener('recharge-sdk:ready', () => resolve(window.recharge), { once: true });
        let n = 0;
        const t = setInterval(() => {
          if (window.recharge && window.__rechargeInitialized) { clearInterval(t); resolve(window.recharge); }
          else if (++n > 50) { clearInterval(t); resolve(window.recharge || null); }
        }, 100);
      });
    }

    setupFilters() {
      if (!this.filtersEl) return;
      this.filterGroups = [...this.app.querySelectorAll('.nrb-filter-group')]
        .map((g) => [...g.querySelectorAll('.nrb-filter[data-tag]')].map((btn) => btn.dataset.tag.toLowerCase()));
      this.sidebarGroups?.querySelectorAll('.nrb-filter[data-tag]').forEach((btn) => btn.addEventListener('click', () => this.toggleTag(btn.dataset.tag)));
      this.bindQuickFilters();
      this.readUrlFilters();
      this.applyFilters();
      this.updateFilterCount();
    }

    bindQuickFilters() {
      if (!this.quickEl) return;
      this.quickEl.querySelectorAll('.nrb-filter[data-tag]').forEach((btn) => btn.addEventListener('click', () => this.toggleQuickTag(btn.dataset.tag)));
    }

    toggleTag(tag) {
      const key = tag.toLowerCase();
      if (this.activeTags.has(key)) this.activeTags.delete(key);
      else this.activeTags.add(key);
      this.syncFilterButtons();
      this.applyFilters();
      this.updateFilterCount();
      this.writeUrlFilters();
    }

    toggleQuickTag(tag) {
      const key = tag.toLowerCase();
      const wasActive = this.activeTags.has(key);
      this.quickEl.querySelectorAll('.nrb-filter[data-tag]').forEach((btn) => this.activeTags.delete(btn.dataset.tag.toLowerCase()));
      if (!wasActive) this.activeTags.add(key);
      this.syncFilterButtons();
      this.applyFilters();
      this.updateFilterCount();
      this.writeUrlFilters();
    }

    syncFilterButtons() {
      this.app.querySelectorAll('.nrb-filter[data-tag]').forEach((btn) => {
        btn.setAttribute('aria-pressed', this.activeTags.has(btn.dataset.tag.toLowerCase()) ? 'true' : 'false');
      });
    }

    updateFilterCount() {
      const total = this.activeTags.size;
      if (this.filterCountEl) this.filterCountEl.textContent = total ? `(${total})` : '';
      const applyCount = this.sidebar?.querySelector('.nrb-sidebar__apply-count');
      if (applyCount) applyCount.dataset.count = total ? ` (${total})` : '';
      this.sidebarGroups?.querySelectorAll('.nrb-filter-group').forEach((group) => {
        const target = group.querySelector('.nrb-filter-group__count');
        if (!target) return;
        const count = [...group.querySelectorAll('.nrb-filter[data-tag]')]
          .filter((btn) => this.activeTags.has(btn.dataset.tag.toLowerCase())).length;
        target.dataset.count = count ? ` (${count})` : '';
      });
    }

    activeByGroup() {
      const result = this.filterGroups
        .map((tags) => tags.filter((t) => this.activeTags.has(t)))
        .filter((tags) => tags.length);
      const grouped = new Set(this.filterGroups.flat());
      [...this.activeTags].filter((t) => !grouped.has(t)).forEach((t) => result.push([t]));
      return result;
    }

    applyFilters() {
      const groups = this.activeByGroup();
      this.meals.forEach((m) => {
        const tags = m.dataset.tags || '';
        const visible = groups.every((g) => g.some((t) => tags.includes('|' + t + '|')));
        m.classList.toggle('nrb-meal--hidden', !visible);
      });
      this.placeBreakers();
    }

    placeBreakers() {
      if (!this.mealsGrid || !this.breakerSources.length) return;
      this.mealsGrid.querySelectorAll('.pm-0123-breaker-item').forEach((el) => el.remove());
      const cols = getComputedStyle(this.mealsGrid).gridTemplateColumns;
      const columnCount = cols && cols !== 'none' ? cols.split(' ').filter(Boolean).length : 1;
      const step = Math.max(columnCount, Math.round(8 / columnCount) * columnCount);
      const visible = this.meals.filter((m) => !m.classList.contains('nrb-meal--hidden'));
      let bi = 0;
      for (let i = step - 1; i < visible.length; i += step) {
        const clone = this.breakerSources[bi % this.breakerSources.length].cloneNode(true);
        visible[i].insertAdjacentElement('afterend', clone);
        bi++;
      }
    }

    resetFilters() {
      this.activeTags.clear();
      this.syncFilterButtons();
      this.applyFilters();
      this.updateFilterCount();
      this.writeUrlFilters();
    }

    readUrlFilters() {
      // Accept both a comma-joined value (?filter=a,b) and repeated keys (?filter=a&filter=b).
      // Comma-joined is the canonical form: some URL normalizers (e.g. A/B tools like ABlyft)
      // collapse repeated query keys to the last value on load, which would silently drop all
      // but one filter. A single key survives, so incoming links must use the comma form.
      const wanted = new URLSearchParams(location.search).getAll('filter')
        .flatMap((v) => v.split(','))
        .map((t) => t.trim().toLowerCase())
        .map((t) => (t === 'abnehmen' ? 'kalorien sparen' : t))
        .filter(Boolean);
      const valid = new Set([...this.app.querySelectorAll('.nrb-filter[data-tag]')].map((b) => b.dataset.tag.toLowerCase()));
      wanted.forEach((t) => { if (valid.has(t)) this.activeTags.add(t); });
      this.syncFilterButtons();
      this.updateFilterCount();
    }

    writeUrlFilters() {
      const params = new URLSearchParams(location.search);
      params.delete('filter');
      // Single comma-joined key, never repeated keys — see readUrlFilters (survives URL normalizers).
      if (this.activeTags.size) params.set('filter', [...this.activeTags].join(','));
      const qs = params.toString();
      history.replaceState(null, '', qs ? `${location.pathname}?${qs}` : location.pathname);
    }

    lockScroll() {
      if (this.scrollLocked) return;
      const sbw = window.innerWidth - document.documentElement.clientWidth;
      this.prevBodyPadRight = document.body.style.paddingRight;
      document.body.style.overflow = 'hidden';
      if (sbw > 0) document.body.style.paddingRight = `${sbw}px`;
      this.scrollLocked = true;
    }

    unlockScroll() {
      if (!this.scrollLocked) return;
      document.body.style.overflow = '';
      document.body.style.paddingRight = this.prevBodyPadRight || '';
      this.scrollLocked = false;
    }

    openSidebar() {
      if (!this.sidebar) return;
      this.sidebarLastFocused = document.activeElement;
      this.sidebar.hidden = false;
      this.filtersOpen?.setAttribute('aria-expanded', 'true');
      this.lockScroll();
      this.sidebar.querySelector('.nrb-sidebar__panel')?.focus();
    }

    closeSidebar() {
      if (!this.sidebar) return;
      this.sidebar.hidden = true;
      this.filtersOpen?.setAttribute('aria-expanded', 'false');
      this.unlockScroll();
      this.sidebarLastFocused?.focus?.();
    }

    get count() {
      return this.meals.reduce((sum, m) => sum + qtyOf(m), 0);
    }

    get subscribed() {
      return this.subscribe ? this.subscribe.checked : false;
    }

    get sellingPlanGroup() {
      return this.subscribed && this.frequency ? this.frequency.value : null;
    }

    syncDelivery() {
      this.frequencies.forEach((sel) => { sel.hidden = !this.subscribed; });
      this.updateBadgePrices();
    }

    // AT legacy modal: the in-popup plan buttons drive the (hidden) subscribe checkbox `get subscribed` reads.
    selectPlan(subscribed) {
      if (this.subscribe) this.subscribe.checked = subscribed;
      this.syncDelivery();
      this.syncPlanUI();
      if (this.modal && !this.modal.hidden) this.renderModal();
    }

    // Reflect the subscription state on the AT plan switch: active button + frequency visibility. No-op without the switch (default modal).
    syncPlanUI() {
      if (!this.planSwitch) return;
      const sub = this.subscribed;
      this.planSwitch.querySelector('[data-plan="sub"]')?.classList.toggle('is-active', sub);
      this.planSwitch.querySelector('[data-plan="once"]')?.classList.toggle('is-active', !sub);
      this.planFrequency?.classList.toggle('is-active', sub);
    }

    // AT plan buttons each show their own total (subscription vs one-time), computed the same way the cart charges each option.
    renderPlanPrices() {
      if (!this.planSwitch) return;
      let subC = 0;
      let onceC = 0;
      this.selectedMeals.forEach((m) => {
        const q = qtyOf(m);
        subC += this.mealTierCents(m, true) * q;
        onceC += this.mealTierCents(m, false) * q;
      });
      const subEl = this.planSwitch.querySelector('[data-plan-price="sub"]');
      const onceEl = this.planSwitch.querySelector('[data-plan-price="once"]');
      if (subEl) subEl.textContent = this.money(this.applyExtra(subC));
      if (onceEl) onceEl.textContent = this.money(this.applyExtra(onceC));
    }

    writeQty(meal, q) {
      const wrap = meal.querySelector('.nrb-meal__qty');
      if (!wrap) return; // sold-out meal, no stepper
      wrap.dataset.qty = q;
      input(meal).value = q;
      wrap.querySelector('.nrb-qty__minus').disabled = q === 0;
    }

    setQty(meal, q) {
      q = Math.max(0, Number.isNaN(q) ? 0 : q);
      const others = this.count - qtyOf(meal);
      q = Math.min(q, Math.max(0, this.max - others));
      this.writeQty(meal, q);
      this.render();
    }

    bindMeal(meal) {
      const wrap = meal.querySelector('.nrb-meal__qty');
      if (!wrap || wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      wrap.querySelector('.nrb-qty__plus').addEventListener('click', () => this.setQty(meal, qtyOf(meal) + 1));
      wrap.querySelector('.nrb-qty__minus').addEventListener('click', () => this.setQty(meal, qtyOf(meal) - 1));
      input(meal).addEventListener('change', () => this.setQty(meal, qtyOf(meal)));
    }

    applySize(btn) {
      this.sizes.forEach((s) => {
        const on = s === btn;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      this.max = Number(btn.dataset.quantity) || 0;
      this.applyPreselect(btn.dataset.preselect);
      this.updateBadgePrices();
    }

    applyPreselect(text) {
      // Never override a frequency the customer picked manually.
      if (this.frequencyTouched || !text || !this.frequency) return;
      const opt = this.findPlanOption(text);
      if (opt) {
        this.mirrorFrequency(opt.value);
        this.syncDelivery();
      }
    }

    mirrorFrequency(value) {
      this.frequencies.forEach((sel) => { sel.value = value; });
    }

    findPlanOption(name) {
      const options = [...this.frequency.options];
      const exact = options.find((o) => (o.dataset.planName || o.textContent).trim() === name);
      if (exact) return exact;

      const weeks = this.planWeeks(name);
      if (!weeks) return null;
      if (weeks > 1) return options.find((o) => this.planWeeks(o.textContent) === weeks) || null;

      const numbered = options.findIndex((o) => /\d/.test(o.textContent));
      if (numbered > 0) return options[numbered - 1];
      return options[0] || null;
    }

    planWeeks(text) {
      const label = (text || '').trim();
      if (!label) return 0;
      const n = parseInt(label.match(/\d+/)?.[0], 10);
      return Number.isFinite(n) ? n : 1;
    }

    selectSize(btn) {
      this.applySize(btn);
      this.writeVariantUrl(btn);
      this.render();
    }

    sizeTitle(btn) {
      return btn.dataset.variantTitle || btn.querySelector('.nrb-size__title')?.textContent.trim() || '';
    }

    readVariantUrl() {
      const title = new URLSearchParams(location.search).get('variant');
      return title ? this.sizes.find((s) => this.sizeTitle(s) === title) ?? null : null;
    }

    writeVariantUrl(btn) {
      const params = new URLSearchParams(location.search);
      params.set('variant', this.sizeTitle(btn));
      history.replaceState(null, '', `${location.pathname}?${params.toString()}`);
    }

    render() {
      const count = this.count;
      const full = this.max > 0 && count >= this.max;
      if (this.amount) {
        const bar = this.amount.querySelector('progress');
        if (bar) { bar.max = this.max; bar.value = count; }
        this.amount.querySelector('[data-value]').textContent = count;
        this.amount.querySelector('[data-title]').textContent = `${this.max} Meals`;
      }
      this.sizes.forEach((s) => {
        const disabled = (Number(s.dataset.quantity) || 0) < count;
        if (s.disabled !== disabled) {
          s.disabled = disabled;
          s.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        }
      });
      if (full !== this.wasFull) {
        this.app.classList.toggle('is-full', full);
        if (this.buy) this.buy.hidden = !full;
        if (full) this.openModal();
        this.wasFull = full;
      }
    }

    resetSelection() {
      this.meals.forEach((m) => this.writeQty(m, 0));
      this.render();
    }

    // Per-meal price with the box-tier discount only (no campaign discount). `subscribed` lets AT price both plan options at once.
    mealTierCents(m, subscribed) {
      const base = Number(m.dataset.price) || 0;
      const sub = Number(m.dataset.subPrice) || base;
      const unit = subscribed ? sub : base;
      const tierPct = Number(this.activeSize()?.dataset.tier) || 0;
      return unit - Math.floor(unit * tierPct / 100);
    }

    // Apply the optional campaign discount, floored. Applied once on the summed total (not per meal) so the displayed price never drops below what the cart charges the whole bundle line.
    applyExtra(cents) {
      return this.extraDiscountPct > 0 ? cents - Math.floor(cents * this.extraDiscountPct / 100) : cents;
    }

    setBadgePrice(badge, text) {
      let el = badge.querySelector('.rb-badge-portion');
      if (!text) { el?.remove(); return; }
      if (!el) {
        el = document.createElement('span');
        el.className = 'rb-badge-portion';
        badge.appendChild(el);
      }
      el.textContent = text;
    }

    updateBadgePrices() {
      const firstRun = !this.badgesAnimated;
      this.meals.forEach((m) => {
        const tier = this.mealTierCents(m, this.subscribed);
        // Per-portion price: with a campaign discount, floor to the portion FIRST then apply the discount — matches the box-button "ab" price and avoids ±1 cent drift. Without a discount, keep the original ceil rounding (unaffected).
        const perPortion = (n) => (n <= 0 ? null : this.extraDiscountPct > 0 ? this.applyExtra(Math.floor(tier / n)) : Math.ceil(tier / n));
        const apply = (badge, text) => {
          if (!badge) return;
          this.setBadgePrice(badge, text);
          if (firstRun && text) badge.classList.add('rb-badge--in');
        };
        apply(m.querySelector('.rb-badge--xl'), tier > 0 ? `| ${this.money(perPortion(2))} p.P.` : null);
        const portionsBadge = m.querySelector('.rb-badge--portions');
        const portions = portionsBadge ? parseInt(portionsBadge.dataset.portions, 10) || 0 : 0;
        apply(portionsBadge, tier > 0 && portions > 0 ? `| ${this.money(perPortion(portions))} p.P.` : null);
        apply(m.querySelector('.rb-badge--premium'), tier > 0 ? `| ${this.money(this.applyExtra(tier))}` : null);
      });
      if (firstRun) this.badgesAnimated = true;
    }

    get selectedMeals() { return this.meals.filter((m) => qtyOf(m) > 0); }

    activeSize() { return this.sizes.find((s) => s.classList.contains('is-active')) ?? this.sizes[0]; }

    money(cents) {
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      const locale = document.documentElement.lang || 'de';
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    }

    dialog() { return this.modal?.querySelector('.nrb-modal__overview'); }

    focusable(root) {
      if (!root) return [];
      return [...root.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter((el) => el.offsetParent !== null);
    }

    activeOverlay() {
      if (this.infoModal && !this.infoModal.hidden) return { root: this.infoModal.querySelector('.nrb-info__dialog'), close: () => this.closeInfo() };
      if (this.sidebar && !this.sidebar.hidden) return { root: this.sidebar.querySelector('.nrb-sidebar__panel'), close: () => this.closeSidebar() };
      if (this.modal && !this.modal.hidden) return { root: this.dialog(), close: () => this.closeModal() };
      return null;
    }

    openInfo(meal) {
      if (!this.infoModal) return;
      const imgSlot = this.infoModal.querySelector('[data-info-img]');
      if (imgSlot) imgSlot.innerHTML = meal.querySelector('.nrb-meal__img')?.outerHTML || '';
      const titleSlot = this.infoModal.querySelector('[data-info-title]');
      if (titleSlot) titleSlot.textContent = meal.querySelector('.nrb-meal__title')?.textContent.trim() || '';
      const descSlot = this.infoModal.querySelector('[data-info-desc]');
      if (descSlot) {
        const tpl = meal.querySelector('.nrb-meal__desc');
        descSlot.innerHTML = tpl ? tpl.innerHTML : '';
      }
      this.infoModal.querySelector('.nrb-info__scroll')?.scrollTo(0, 0);
      this.infoLastFocused = document.activeElement;
      this.infoModal.hidden = false;
      this.lockScroll();
      this.infoModal.querySelector('.nrb-info__dialog')?.focus();
    }

    closeInfo() {
      if (!this.infoModal) return;
      this.infoModal.hidden = true;
      this.unlockScroll();
      this.infoLastFocused?.focus?.();
    }

    onKeydown(e) {
      const overlay = this.activeOverlay();
      if (!overlay) return;
      if (e.key === 'Escape') { overlay.close(); return; }
      if (e.key !== 'Tab') return;
      const f = this.focusable(overlay.root);
      if (!f.length) { e.preventDefault(); overlay.root?.focus(); return; }
      const first = f[0];
      const last = f[f.length - 1];
      const active = document.activeElement;
      if (!f.includes(active)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
      if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    }

    openModal() {
      if (!this.modal) return;
      this.lastFocused = document.activeElement;
      this.setMsg('');
      this.renderModal();
      this.modal.hidden = false;
      this.lockScroll();
      this.dialog()?.focus();
    }

    closeModal() {
      if (!this.modal) return;
      this.modal.hidden = true;
      this.unlockScroll();
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') this.lastFocused.focus();
      this.lastFocused = null;
    }

    renderModal() {
      const active = this.activeSize();
      const titleFor = this.modal?.querySelector(`.nrb-modal__title-for[data-variant-id="${active?.dataset.variantId}"]`);
      if (this.modalTitle && titleFor) this.modalTitle.textContent = titleFor.textContent.trim();
      if (this.modalProducts) {
        this.modalProducts.innerHTML = this.selectedMeals.map((m) => {
          const q = qtyOf(m);
          const title = m.querySelector('.nrb-meal__title')?.textContent.trim() || '';
          const img = m.dataset.popupImg || m.querySelector('.nrb-meal__img')?.getAttribute('src') || '';
          return `<div class="nrb-modal__product">${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : ''}<span>${q}&times; ${esc(title)}</span></div>`;
        }).join('');
      }
      let oldC = 0;
      let newC = 0;
      this.selectedMeals.forEach((m) => {
        const q = qtyOf(m);
        oldC += (Number(m.dataset.price) || 0) * q;
        newC += this.mealTierCents(m, this.subscribed) * q;
      });
      // Campaign discount applied once on the summed total (matches the cart's per-line code application).
      newC = this.applyExtra(newC);
      if (this.modalPriceNew) this.modalPriceNew.textContent = this.money(newC);
      if (this.modalPriceOld) this.modalPriceOld.textContent = oldC !== newC ? this.money(oldC) : '';
      this.renderPlanPrices();
      this.syncPlanUI();
      this.modal.querySelectorAll('[data-upsell]').forEach((u) => {
        u.hidden = u.dataset.variantId !== active?.dataset.variantId;
      });
    }

    applyUpsell(btn) {
      const qty = Number(btn.dataset.quantity) || 0;
      const next = this.sizes.find((s) => Number(s.dataset.quantity) === qty);
      if (next) this.selectSize(next);
      this.closeModal();
    }

    buildSelections() {
      const groupId = this.sellingPlanGroup;
      return this.meals
        .filter((m) => qtyOf(m) > 0)
        .map((m) => {
          const selection = {
            collectionId: this.collectionId,
            externalProductId: m.dataset.productId,
            externalVariantId: m.dataset.variantId,
            quantity: qtyOf(m),
          };
          if (groupId) {
            const plans = JSON.parse(m.dataset.sellingPlans || '{}');
            if (plans[groupId]) selection.sellingPlan = plans[groupId];
          }
          return selection;
        });
    }

    showCartError() {
      // The message line lives inside the modal; open it so the error is visible
      // when the add was triggered from the bar's buy button.
      if (this.modal && this.modal.hidden) this.openModal();
      this.setMsg(this.cartError, true);
    }

    applyDiscount() {
      // Apply the optional campaign code via the Cart AJAX API before the add, so
      // it's already on the cart token when the drawer opens. Awaited but never
      // rejects: on any error we just move on — the add must never be blocked.
      if (!this.discountCode) return Promise.resolve();
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: this.discountCode }),
      }).catch(() => {});
    }

    async addToCart() {
      if (this.adding) return;
      this.adding = true;
      const buttons = [this.modalAtc, this.buy].filter(Boolean);
      const adding = this.addingLabel?.textContent.trim();
      buttons.forEach((btn) => {
        btn.disabled = true;
        btn.dataset.label = btn.dataset.label || btn.textContent;
        if (adding) btn.textContent = adding;
      });
      this.setMsg('');
      try {
        const sdk = await this.whenRecharge();
        if (!sdk || !sdk.bundle) throw new Error('Recharge SDK not available');
        const active = this.activeSize();
        const bundle = {
          externalVariantId: active.dataset.variantId,
          externalProductId: this.bundleProductId,
          selections: this.buildSelections(),
        };
        const items = await sdk.bundle.getDynamicBundleItems(bundle, this.bundleHandle);
        // Apply the optional campaign code first so it's on the cart when the drawer opens; never blocks the add.
        await this.applyDiscount();
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          // Shopify returns the real reason (out of stock, invalid selling plan, …) in the body.
          const body = await res.json().catch(() => null);
          console.error('[nrb] cart/add.js rejected', res.status, body, 'items:', items);
          throw new Error(`cart/add.js ${res.status} ${body?.description || body?.message || ''}`.trim());
        }
        document.dispatchEvent(new CustomEvent('nrb:added', { detail: { items } }));
        this.closeModal();
        this.resetSelection();
        // The add succeeded; a failing drawer refresh must not surface as a cart error.
        try {
          if (window.RechargeBundle && typeof window.RechargeBundle.onAddToCart === 'function') {
            await window.RechargeBundle.onAddToCart();
          }
        } catch (e) {
          console.error('[nrb] cart drawer refresh failed', e);
        }
      } catch (err) {
        console.error('[nrb] add to cart failed', err);
        this.showCartError();
      } finally {
        buttons.forEach((btn) => {
          btn.disabled = false;
          btn.textContent = btn.dataset.label;
        });
        this.adding = false;
      }
    }

    setMsg(text, isError = false) {
      if (!this.msg) return;
      this.msg.textContent = text;
      this.msg.classList.toggle('is-error', isError);
    }
  }

  // Measure the fixed "qab" announcement bar and expose its height as --qab-height, so the sticky config bar can offset below it instead of sliding underneath. Runs once per page.
  const syncAnnouncementBar = () => {
    if (document.documentElement.dataset.nrbQab) return;
    document.documentElement.dataset.nrbQab = '1';
    const BAR_IDS = ['#qab_background', '#qab_bar', '#qab_container'];
    const setHeight = () => {
      let h = 0;
      for (const sel of BAR_IDS) {
        const el = document.querySelector(sel);
        if (!el) continue;
        const s = getComputedStyle(el);
        const r = el.getBoundingClientRect();
        if ((s.position === 'fixed' || s.position === 'sticky') && r.top <= 1 && r.height > 0) {
          h = Math.max(h, Math.round(r.height));
        }
      }
      document.documentElement.style.setProperty('--qab-height', h + 'px');
      document.body.classList.toggle('has-announcement-bar', h > 0);
    };
    const ro = 'ResizeObserver' in window ? new ResizeObserver(setHeight) : null;
    const observed = new Set();
    const attach = () => {
      setHeight();
      if (!ro) return;
      for (const sel of BAR_IDS) {
        const el = document.querySelector(sel);
        if (el && !observed.has(el)) { observed.add(el); ro.observe(el); }
      }
    };
    attach();
    window.addEventListener('resize', setHeight);
    if ('MutationObserver' in window) {
      const mo = new MutationObserver(() => {
        attach();
        if (document.querySelector('#qab_background')) mo.disconnect();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  };

  const boot = () => {
    syncAnnouncementBar();
    document.querySelectorAll('.native-recharge-bundle .nrb-app').forEach((app) => {
      if (app.dataset.nrbReady) return;
      app.dataset.nrbReady = '1';
      new Configurator(app);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
